import * as React from 'react';
import Modal from 'react-modal';
import cn from 'classnames'
const moment = require('moment');

import Alert from "../controls/standart/Alert";
import logger from "redux-logger";

interface Props {
    callback: <T = null>(args?: T) => void
}

interface State {
    open: boolean,
    errors: null | {},
    files: any
}

const schemaForm = [
    {
        id: 'deferralReasonDesc',
        label: 'Комментарий',
        tageName: 'textarea',
        hint: null
    },
    {
        id: 'deferralDate',
        label: 'Планируемый срок',
        tageName: 'input',
        type: 'date',
        autoComplete: 'true',
        min: moment().format('YYYY-MM-DD'),
        hint: null,
    },
    {
        id: 'fileDeferralReason',
        label: 'Уведомление',
        tageName: 'input',
        type: 'file',
        accept: '.pdf,.jpeg,.jpg,.doc,.docx,.xls,.xlsx,.zip',
        hint: 'Допустимые форматы файлов PDF,JPEG,JPG,DOC,DOCX,XLS,XLSX,ZIP \n Максимальное количество файлов 1 \n Максимальный размер файла 25 МБ',
        useHandler: true,
    },
    {
        id: 'fileDeferralLetters',
        label: 'Информационное письмо контрагента/подрядчика с указанием причины задержки.',
        tageName: 'input',
        type: 'file',
        accept: '.pdf,.jpeg,.jpg,.doc,.docx,.xls,.xlsx,.zip',
        multiple: true,
        hint: 'Допустимые форматы файлов PDF,JPEG,JPG,DOC,DOCX,XLS,XLSX,ZIP \n Максимальное количество файлов 10 \n Максимальный размер файла 10 МБ',
        useHandler: true,
        list: true,
    },
]

const rules = {
    'deferralReasonDesc': {
       required: true,
    },
    "deferralDate": {
        required: true,
    },
    "fileDeferralReason": {
        required: true,
        formatFile: /(\.pdf|\.jpeg|\.jpg|\.doc|\.docx|\.xls|\.xlsx|\.zip)$/i,
        maxSize: 26214400
    },
    "fileDeferralLetters": {
        required: true,
        formatFile: /(\.pdf|\.jpeg|\.jpg|\.doc|\.docx|\.xls|\.xlsx|\.zip)$/i,
        maxCountFiles: 10,
        maxSize: 10485760
    }
}

let filesArrayToCheck = [];

function validateField(field: HTMLFormElement, rules) {
    if (!field) {
        return null
    }

    for (const rule in rules) {
        switch (rule) {
            case 'required':
                if (!field.value) {
                    return 'Поле обязательно';
                }
                continue;

            case 'formatFile':
                if (!rules[rule].test(field.value)) {
                    field.value = '';
                    return 'Неверный формат';
                }
                continue;

            case 'maxCountFiles':
                if (field.files && field.files.length > rules[rule]) {
                    return `Поле не должно содержать больше ${rules[rule]} файлов`;
                }
                continue;

            default:
                return null;
        }
    }

    return null;
}

function validateFields (fields) {
    const errors = {}
    for (const field in fields) {
        const error = validateField(fields[field], rules[field])
        if (error) {
            errors[field] = error;
        }
    }
    return errors;
}

class RequestReportModal extends React.Component<Props, State> {
    fieldRefs:  Record<string, HTMLFormElement>= {};

    state = {
        open: false,
        errors: {},
        files: [],
    }

    public show = (event?: React.MouseEvent<HTMLButtonElement>) => {
        if (event) {
            event.preventDefault();
        }
        this.setState({open: true, errors: {}, files: []})
    };

    public onClose = (event?: React.MouseEvent<HTMLButtonElement>): void => {
        if (event) {
            event.preventDefault();
        }
        filesArrayToCheck = [];
        this.setState({open: false, errors: {}, files: []});
    }

    onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const errors = validateFields(this.fieldRefs);
        
        if (JSON.stringify(errors) !== '{}') {
            this.setState({errors})
            return
        }
        this.onClose();

        //Полностью замещаем объект формы значениями файлов из state REV-477
        const formData = new FormData(event.currentTarget);
        formData.delete('fileDeferralLetters');
        for(let item of this.state.files){
            formData.append('fileDeferralLetters', item);
        }

        this.props.callback(formData)
    }

	handleSelectedFiles = (event, list) => {
		const files = Array.from(event.target.files);
        if (list) {
            filesArrayToCheck = [...filesArrayToCheck, ...files]
        }

        const fileExceedsSize: any = files.find((file: any) => file.size > rules[event.target.name].maxSize);

		if (fileExceedsSize) {
			event.target.value = "";
			alert(`Файл ${fileExceedsSize.name} превышает допустимый размер`);
			return;
		}

		if (files.length > 10 || filesArrayToCheck.length > 10) {
			event.target.value = "";
            filesArrayToCheck = filesArrayToCheck.splice(0, filesArrayToCheck.length - files.length)
			alert("Превышено максимальное количество файлов");
			return;
		}
        
		if (list) {
			this.setState({
                files: [...this.state.files, ...files]
            });
		}
	};

    render() {
        const {errors, files} = this.state;
        console.log(this.state);
        return (
            <Modal isOpen={this.state.open} ariaHideApp={false}
                   className='react-bs-insert-modal modal-dialog'
                   contentLabel='Modal'>
                <form className="modal-content react-bs-table-insert-modal" onSubmit={this.onSubmit}>
                    <div className="modal-header">
                        <button type="button" className="close" onClick={this.onClose}>
                            <span aria-hidden="true">×</span>
                        </button>
                        <h4 className="modal-title">Запрос продления срока предоставления отчета</h4>
                    </div>
                    <div className="modal-body">
                        {schemaForm && schemaForm.map(field => {
                            const {id, label, tageName, type, hint, useHandler, list, ...otherProps} = field
                            const TagName = tageName;

                            return (
                                <div
                                    key={id}
                                    style={{marginBottom: '1.75rem'}}
                                    className={cn('form-group', {'has-error': errors && errors[id]})}
                                >
                                    <label htmlFor={id}>{label}</label>

                                    {list && files.length > 1 && files.map((file) => <div className="form-control" style={{display: 'flex', alignItems: 'center'}}>
                                        <img style={{height: 20, display: 'inline-block', marginRight: 8 }} src={require('../../static/img/icon-file.png')}/> {file.name}
                                    </div>)}

                                    <TagName
                                        className="form-control"
                                        ref={node => this.fieldRefs[id] = node}
                                        name={id}
                                        type={type}
                                        {...useHandler ? {onChange: (e) => this.handleSelectedFiles(e, list) } : {}}
                                        {...otherProps}
                                    />
                                    {errors && errors[id] && <Alert>{errors[id]}</Alert>}
                                    {hint && <Alert className={'warning'}>{hint}</Alert>}
                                </div>
                            )
                        })}
                    </div>
                    <div className="modal-footer">
                        <button type="submit" className="btn btn-primary">Направить запрос</button>
                        <button type="button" className="btn btn-default btn-secondary" onClick={this.onClose}>Отмена</button>
                    </div>
                </form>
            </Modal>
        );
    }
}
export default RequestReportModal;


// WEBPACK FOOTER //
// ./src/components/request/RequestReportModal.tsx